module.exports = __webpack_public_path__ + "static/SquareSerif-Book-webfont-f34558fe88886fa89c1aa20af7a7102d.woff2";